<template>
  <div class="loadingDiv" v-if="active">
    <!-- 데스크톱: 기존 GIF 스피너 -->
    <div class="loadingImgDiv" v-if="!isMobile">
      <img :src="loadingGif" alt="로딩 중" />
    </div>

    <!-- 모바일: CSS 스피너 -->
    <div class="loadingImgDiv" v-if="isMobile">
      <div class="css-spinner"></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { defineProps } from 'vue';
import loadingGif from '@/assets/images/loading.gif';

// 부모로부터 전달받는 active prop 정의
defineProps({
  active: Boolean,
});

// 현재 경로 가져오기
const route = useRoute();

// /mobile/로 시작하는 경로인지 확인
const isMobile = computed(() => {
  return route.path.startsWith('/mobile');
});
</script>

<style scoped>
.loadingDiv {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3000;
  background-color: #65a4e0;
  opacity: 0.3;
  pointer-events: all; /* 클릭/포커스 차단 */
}
.loadingImgDiv {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* CSS 기반 원형 스피너 (모바일용) */
.css-spinner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid rgba(0, 136, 204, 0.3);
  border-top-color: #0088cc;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
